// extracted by mini-css-extract-plugin
export default {"realtor-logo":"xLCtL","realtorLogo":"xLCtL","skeleton-placeholder-pulse":"jXvYC","skeletonPlaceholderPulse":"jXvYC"};